module.exports = __webpack_public_path__ + "img/wedcr10.58a8a9c9.jpg";